import { render, staticRenderFns } from "./CopiarNotaFiscal.vue?vue&type=template&id=0d5d4dc8&"
import script from "./CopiarNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./CopiarNotaFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports